import React, { useEffect, useState, useRef, useCallback } from 'react';

import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Images
import itcounsulting from "../img/itcounsulting.jpg";
import cloud from "../img/cloud.jpg";
import bps from "../img/bps.jpg";
import ai from "../img/ai.jpg";
import dm from "../img/dm.jpg";
import cyber from "../img/cyber.jpg";
import skill from "../img/skill.jpg";
import csd from "../img/csd.jpg";
import ui from "../img/ui.jpg";
import whobanner from "../img/ourcorexperts.jpg";

const OurServices = () => {
  const SCROLL_SHOW_THRESHOLD = 300;
    const [showScroll, setShowScroll] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);
    const [isScrolling, setIsScrolling] = useState(false);
    const scrollTimeoutRef = useRef(null);
  
    const RADIUS = 49;
    const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
  const dashOffset =
    CIRCUMFERENCE - (scrollProgress / 100) * CIRCUMFERENCE;
    const onScroll = useCallback(() => {
      const sc = window.scrollY || window.pageYOffset;
      setShowScroll(sc > SCROLL_SHOW_THRESHOLD);
  
      const doc = document.documentElement;
      const totalScroll = Math.max(0, doc.scrollHeight - doc.clientHeight);
      const progress = totalScroll > 0 ? (sc / totalScroll) * 100 : 0;
      setScrollProgress(Math.min(100, Math.max(0, progress)));
  
      setIsScrolling(true);
  
      if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
  
      scrollTimeoutRef.current = setTimeout(() => {
        setIsScrolling(false);
        scrollTimeoutRef.current = null;
      }, 250);
    }, []);
  
    useEffect(() => {
      window.scrollTo(0, 0);
      onScroll();
  
      window.addEventListener("scroll", onScroll, { passive: true });
  
      return () => {
        window.removeEventListener("scroll", onScroll);
        if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current);
      };
    }, [onScroll]);
  
    const scrollToTop = useCallback(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
  
    const handleKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        scrollToTop();
      }
    };
  
  const featuredServices = [
    {
      title: "Custom Software Development",
      description:
        "We build secure, scalable, and innovative software solutions that drive real business growth and digital transformation.",
      image: csd,
      link: "/custom-software-development",
      icon: "fa-laptop-code",
    },
    {
      title: "IT Support & Managed Services",
      description:
        "We help businesses in Hyderabad run smoothly and grow efficiently with reliable, proactive IT support and managed services.",
      image: itcounsulting,
      link: "/it-support-services",
      icon: "fa-headset",
    },
    {
      title: "Cloud & Infrastructure Services",
      description:
        "Trusted cloud service providers delivering secure, scalable, and cost-effective cloud solutions for modern business success.",
      image: cloud,
      link: "/cloud-service-providers",
      icon: "fa-cloud",
    },
    {
      title: "Business Process Outsourcing (BPO)",
      description:
        "Boost efficiency, reduce operational costs, and enhance customer satisfaction with our reliable and intelligent BPO solutions.",
      image: bps,
      link: "/bpo-services",
      icon: "fa-users-cog",
    },
    {
      title: "AI Chatbot Development Services",
      description:
        "Automate customer interactions and boost engagement with AI chatbot development services. Smart chatbots, NLP and virtual assistants for your business.",
      image: ai,
      link: "/ai-chatbot-development-services",
      icon: "fa-chart-line",
    },
    {
      title: "Digital Marketing Services",
      description:
        "Transform your brand’s digital presence with AI-driven, data-backed strategies that deliver measurable growth and engagement.",
      image: dm,
      link: "/digital-marketing-services",
      icon: "fa-bullhorn",
    },
    {
      title: "UI/UX Design Services",
      description:
        "Get modern, intuitive, and conversion-focused websites & mobile app designs that delight users and elevate your brand.",
      image: ui,
      link: "/ui-ux-design-services",
      icon: "fa-palette",
    },
    {
      title: "Cybersecurity Services",
      description:
        "Protect your business with advanced cybersecurity solutions, proactive threat detection, and complete data assurance.",
      image: cyber,
      link: "/cybersecurity-services",
      icon: "fa-shield-alt",
    },
  ];

  return (
    <div className="min-h-screen bg-white font-sans">
      <Helmet>
        <title>Our Services | SecurXpert Technologies - Hyderabad</title>
        <meta
          name="description"
          content="Explore SecurXpert's services: Custom Software, IT Support, Cloud, Cybersecurity, Mobile Apps, Data Analytics, UI/UX & Digital Transformation."
        />
        <link rel="canonical" href="https://securxperts.com/our-services" />
      </Helmet>

      <Navbar />

      {/* Hero Banner */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          <div className="absolute inset-0 bg-black/70"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
              Our Services
            </h1>

            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="hover:underline">Home</Link>
               <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Our Services</span>
            </div>
          </div>
        </div>
      </header>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-8">
            <h2 className="text-4xl font-extrabold text-[#210A4A]">Our Core Services</h2>
            <p className="text-lg text-gray-600 mt-3">
              From strategy to execution — we deliver future-ready solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredServices.map((service, index) => (
              <div
                key={index}
                className="service-card bg-white rounded-2xl shadow-lg hover:shadow-2xl overflow-hidden transition-all duration-500 group hover:-translate-y-3"
              >

                {/* CLICKABLE IMAGE */}
                <Link to={service.link}>
                  <div className="relative overflow-hidden cursor-pointer">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-56 object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  </div>
                </Link>

                <div className="p-8 text-center">

                  {/* CLICKABLE ICON */}
                  <Link to={service.link}>
                    <div className="icon-circle cursor-pointer mx-auto mb-4 border-2 border-[#421492] w-16 h-16 flex items-center justify-center rounded-full">
                      <i className={`fa ${service.icon} text-[#421492] text-2xl`}></i>
                    </div>
                  </Link>

                  {/* CLICKABLE TITLE */}
                  <Link to={service.link}>
                    <h4 className="text-xl font-bold text-[#210A4A] mb-3 hover:text-[#421492] transition">
                      {service.title}
                    </h4>
                  </Link>

                  <p className="text-gray-600 text-sm mb-6 min-h-[80px]">
                    {service.description}
                  </p>

                  {/* READ MORE BUTTON */}
                  <Link
                    to={service.link}
                    className="inline-flex items-center text-[#421492] font-bold text-sm hover:text-[#210A4A] transition"
                  >
                    READ MORE
                    <svg
                      className="w-5 h-5 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      {/* Scroll to Top Button */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer 
          flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r 
          from-blue-500 to-blue-700 shadow-xl hover:scale-110 transition-all"
        >
          <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r={RADIUS} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="4" />
            <circle
              cx="50"
              cy="50"
              r={RADIUS}
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={dashOffset}
              strokeLinecap="round"
            />
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white relative z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default OurServices;
